import { getMDXComponent } from '@vxrn/mdx-rust/client'
import { useLoader } from 'one'
import React from 'react'
import { Container } from '~/components/Containers'
import { HeadInfo } from '~/components/HeadInfo'
import { MDXProvider } from '~/features/docs/MDXProvider'
import { MDXTabs } from '~/features/docs/MDXTabs'
import { components } from '~/features/mdx/MDXComponents'

export async function loader() {
  const { getMDXBySlug } = await import('~/features/mdx/getMDXBySlug')
  const { frontmatter, code } = await getMDXBySlug('data/etc', 'privacy')
  return {
    frontmatter,
    code,
  }
}

export default function PrivacyPage() {
  const { frontmatter, code } = useLoader(loader)
  const Component = React.useMemo(() => getMDXComponent(code), [code])

  return (
    <>
      <HeadInfo
        title={`${frontmatter.title} | Gui`}
        description={frontmatter.description || ''}
      />

      <Container py="$10">
        <MDXProvider frontmatter={frontmatter}>
          <MDXTabs id="type" defaultValue="styled">
            <Component components={components as any} />
          </MDXTabs>
        </MDXProvider>
      </Container>
    </>
  )
}
